module.exports = __webpack_public_path__ + "static/media/mental-threats@2x.9223017b.png";